export const enum SecurityIssuesTypes {
  NoWhitelist = 'ip_whitelist_not_set',
  Open = 'open_for_all',
  NoProblem = 'no_problems_found',
}
